var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ErrorPage',{attrs:{"code":_vm.$t('views.notFound.code'),"page-title":_vm.$t('views.notFound.error'),"message":_vm.$t('views.notFound.message'),"data-cy":"errorPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }